import { useRef, type FC } from 'react';
import { createProvider } from '../../../utils/createProvider';
import { ToolNavigationNormalizedData, ToolNavigationNormalizedNoData } from '../types';
import { getNormalizedData } from '../utils';

const [Provider, useProvider] = createProvider<ToolNavigationNormalizedData | ToolNavigationNormalizedNoData>({
	contextName: 'ToolNavigationDataRefContext',
	strict: false,
});

export const useToolNavigationDataProvider = useProvider as () => ToolNavigationNormalizedData;

export const ToolNavigationDataProvider: FC<React.PropsWithChildren> = ({ children }) => {
	const dataRef = useRef<ToolNavigationNormalizedData | ToolNavigationNormalizedNoData>(getNormalizedData());

	return <Provider value={dataRef.current}>{children}</Provider>;
};
